var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-item clearFloat"},[_c('cx-background',{attrs:{"infoTips":"支持上传图片","background":_vm.background,"imgType":"10"},on:{"update:background":function($event){_vm.background=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }